import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomescreenComponent } from './homescreen/homescreen.component';
import { AgentsComponent } from './agents/agents.component';


const routes: Routes = [
  { path: '', component: HomescreenComponent },
  { path: 'search', component: HomescreenComponent },
  { path: 'agents', component: AgentsComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
